import { FarmsService } from './../../core/services/admin/farms.service';
import { Farm } from './../../core/models/admin/farms.model';
import {
  filter,
  tap,
  takeUntil,
  debounceTime,
  map,
  delay,
  take,
} from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-search-mult-farm',
  templateUrl: './search-mult-farm.component.html',
})
export class SearchMultFarmComponent implements OnInit {
  @Input() public controlName: FormControl;
  @Input() public formGroup: FormGroup;
  @Input() public label = 'Fazenda';
  public defaultClass = 'flex-auto gt-xs:pr-3';

  @ViewChild('singleSelect') singleSelect: MatSelect;

  public farmServerSideFilteringCtrl: FormControl = new FormControl();

  /** indicate search operation is in progress */
  public searching: boolean = false;

  /** list of banks filtered after simulating server side search */
  public filteredServerSideFarms: ReplaySubject<Farm[]> = new ReplaySubject<
    Farm[]
  >(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  /** list of Farms */
  public farms: Farm[] = [];

  constructor(private _farmService: FarmsService) {}

  ngOnInit(): void {
    this._farmService.getFarmsMemory().subscribe((farms: Farm[]) => {
      this.farms = farms;

      // load the initial bank list
      this.filteredServerSideFarms.next(this.farms.slice());

      this.setInitialValue();
    });

    // listen for search field value changes
    this.farmServerSideFilteringCtrl.valueChanges
      .pipe(
        tap(() => (this.searching = true)),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.farms) {
            return [];
          }
          // TODO: change to call api
          return this.farms.filter(
            farm =>
              search == '' ||
              farm.farm_name.toLowerCase().includes(search) ||
              farm.company_name?.toLowerCase().includes(search) ||
              farm.identity_name?.toLowerCase().includes(search) ||
              farm.state_register?.includes(search) ||
              farm.city?.toLowerCase().includes(search)
          );
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        filteredFarms => {
          this.searching = false;
          this.filteredServerSideFarms.next(filteredFarms);
        },
        error => {
          // no errors in our simulated example
          this.searching = false;
          // handle error...
        }
      );
  }
  getFarmIndex(index): string {
    const f = this.farms.find(f => f.id == index);
    return f?.identity_name || f?.farm_name;
  }

  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue(): void {
    this.filteredServerSideFarms
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        //this.singleSelect.compareWith = (a: number, b: number) => a && b && a === b;
      });
  }
}
